module.exports = __webpack_public_path__ + "static/media/amenity_ping-pong.e72bea23.jpg";